<rpe-page-template title="VÍNCULOS LABORALES" route="main/landing">
  <div slot="content">
    <rpe-entity-vinculo-laboral-form-container></rpe-entity-vinculo-laboral-form-container>
  </div> 
</rpe-page-template>
